<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      clip-rule="evenodd"
      d="m17.5 4c.66 0 1.22.42 1.42 1.01l2.08 5.99v8c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1h-12v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-8l2.08-5.99c.21-.59.76-1.01 1.42-1.01zm-.36 2h-10.29l-1.08 3.11h12.45zm-8.14 7.5c0 .8284-.67157 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.67157-1.5 1.5-1.5 1.5.6716 1.5 1.5zm9 0c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5z"
      fill-rule="evenodd"
    />
  </svg>
</template>
